import { matomoTrackEvent } from '../trackEvent'

import type { MatomoPayload } from '../types'

export type UserMatomoEvent =
  | 'enter_question'
  | 'copy'
  | 'rate_feedback'
  | 'response_load'

export function pushToMatomo(
  eventName: UserMatomoEvent,
  action: string,
  payload: MatomoPayload = {},
  category = 'protege',
) {
  matomoTrackEvent(category, action, eventName, payload)
}

export const ProtegeMatomoActions = {
  requestSummary: 'request_summary',
  copySummary: 'copy_summary',
  feedback: 'summary_feedback',
  responseLoad: 'summary_response_load',
} as const
